var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comm-container input-card-wp"},[_c('div',{staticClass:"input-card-bd"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"input-card-ft"},[_c('div',{staticClass:"input-card-btn",on:{"click":_vm.submit}},[_vm._v("保存")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d1752fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputCardBox.vue
// module id = jupx
// module chunks = 66